import { motion } from 'framer-motion';
import React from 'react';
import { FaBullseye, FaCogs, FaEye, FaSync } from 'react-icons/fa';
import styles from './MethodologyCircle.module.scss';

export const MethodologyCircle: React.FC = () => {
    const steps = [
        {
            icon: FaEye,
            title: 'Identificar',
            description: 'Necessidades e oportunidades',
            position: 'top',
        },
        {
            icon: FaCogs,
            title: 'Projetar',
            description: 'Soluções personalizadas',
            position: 'right',
        },
        {
            icon: FaBullseye,
            title: 'Implementar',
            description: 'Com qualidade e eficiência',
            position: 'bottom',
        },
        {
            icon: FaSync,
            title: 'Melhoria Contínua',
            description: 'Otimização constante',
            position: 'left',
        },
    ];

    return (
        <div className={styles.methodology_container}>
            <div className={styles.circle_wrapper}>
                {/* Círculo central */}
                <motion.div
                    className={styles.central_circle}
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    viewport={{ once: true }}
                >
                    <h3 className={styles.central_title}>Metodologia</h3>
                    <p className={styles.central_subtitle}>Decatron</p>
                </motion.div>

                {/* Círculo externo animado */}
                <motion.div
                    className={styles.outer_circle}
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 20,
                        repeat: Infinity,
                        ease: 'linear',
                    }}
                />

                {/* Steps da metodologia */}
                {steps.map((step, index) => (
                    <motion.div
                        key={index}
                        className={`${styles.step_item} ${styles[step.position]}`}
                        initial={{ opacity: 0, scale: 0 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{
                            duration: 0.6,
                            delay: 0.5 + index * 0.2,
                        }}
                        viewport={{ once: true }}
                        whileHover={{
                            scale: 1.05,
                            transition: { duration: 0.2 },
                        }}
                    >
                        <div className={styles.step_icon}>
                            <step.icon />
                        </div>
                        <div className={styles.step_content}>
                            <h4 className={styles.step_title}>{step.title}</h4>
                            <p className={styles.step_description}>{step.description}</p>
                        </div>

                        {/* Linha conectora */}
                        <div className={styles.connector_line} />
                    </motion.div>
                ))}
            </div>
        </div>
    );
};
